import styled from 'styled-components';

export const SecondarySpan = styled.span<{ color: string }>`
	color: ${props => props.color};
	font-size: 12px;
	font-style: italic;
`;

export const ViewAllDiv = styled.div`
	display: flex;
	padding-right: 10px;
	justify-content: flex-end;
	cursor: pointer;
	& a {
		text-decoration: none;
	}
`;
